import { render, staticRenderFns } from "./JsonPayloadView.vue?vue&type=template&id=5838a5f6&scoped=true&"
import script from "./JsonPayloadView.vue?vue&type=script&lang=ts&"
export * from "./JsonPayloadView.vue?vue&type=script&lang=ts&"
import style0 from "./JsonPayloadView.vue?vue&type=style&index=0&id=5838a5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838a5f6",
  null
  
)

export default component.exports